import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "asHeaderMain" }
const _hoisted_2 = { class: "asHeaderMain_avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "asHeaderMain_user" }
const _hoisted_5 = { class: "asHeaderMain_name" }
const _hoisted_6 = {
  key: 0,
  class: "asHeaderMain_menu"
}
const _hoisted_7 = ["href", "data-analytics-element-target", "data-analytics-element-name"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ac_points_label = _resolveComponent("ac-points-label")!
  const _component_as_external_document = _resolveComponent("as-external-document")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _ctx.PAGE_NAME.HOME }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['asHeaderMain_logo', `-${_ctx.projectId}`]),
          style: _normalizeStyle({
          backgroundImage: `url(${_ctx.logo.src})`,
          maskImage: `url(${_ctx.logo.src})`
        })
        }, null, 6)
      ]),
      _: 1
    }, 8, ["to"]),
    _renderSlot(_ctx.$slots, "breadcrumb"),
    _createVNode(_component_router_link, {
      to: { name: 'points' },
      class: "asHeaderMain_wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.user.avatar,
            alt: "",
            class: "asHeaderMain_photo"
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.username), 1),
          _createVNode(_component_ac_points_label, {
            class: "asHeaderMain_points",
            points: _ctx.userScoreAmount
          }, null, 8, ["points"])
        ])
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "menu", {}, () => [
      _createElementVNode("div", {
        class: "asHeaderMain_setting",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop","self"]))
      }, [
        (_ctx.menuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.user.isAdmin)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "asHeaderMain_item",
                    href: _ctx.urlAdmin,
                    "data-analytics": "",
                    "data-analytics-element-type": "menu_user",
                    "data-analytics-element-target": _ctx.urlAdmin,
                    "data-analytics-element-id": "dashboard",
                    "data-analytics-element-name": _ctx.$t('dashboard')
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "asHeaderMain_icon -ext" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('dashboard')), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (item.type === 'router-link')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: i,
                        to: item.link,
                        class: "asHeaderMain_item",
                        "data-analytics": "",
                        "data-analytics-element-type": "menu_user",
                        "data-analytics-element-target": item.to,
                        "data-analytics-element-id": item.icon,
                        "data-analytics-element-name": item.name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass(["asHeaderMain_icon", `${item.icon}`])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]))
                    : _createCommentVNode("", true),
                  (item.type === 'modal')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "asHeaderMain_item"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["asHeaderMain_icon", `${item.icon}`])
                        }, null, 2),
                        _createVNode(_component_as_external_document, {
                          doc: {
                url: item.link,
                title: item.name
              },
                          "is-modal": true,
                          icon: false
                        }, null, 8, ["doc"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}